import { render, staticRenderFns } from "./UpdateDesignationModal.vue?vue&type=template&id=53f82ce8&"
import script from "./UpdateDesignationModal.vue?vue&type=script&lang=js&"
export * from "./UpdateDesignationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports